// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { fermentationId } from './Fermentation';
import { methanolDetectorHoldEnum } from './MethanolDetectorHoldEnum';
import { methanolDetectorOffReasonEnum } from './MethanolDetectorOffReasonEnum';
import { operatorId } from './Operator';
import { z } from 'zod';
export const fermentationMethanolDetectorHoldId = (z.number());
export const fermentationMethanolDetectorHold = z.object({
    id: fermentationMethanolDetectorHoldId,
    fermentation_id: fermentationId,
    kind: methanolDetectorHoldEnum,
    off_reason: methanolDetectorOffReasonEnum.nullable(),
    started_at: z.date(),
    until: z.date().nullable(),
    ended_at: z.date().nullable(),
    created_by: operatorId.nullable(),
    ended_by: operatorId.nullable(),
    created_at: z.date(),
    updated_at: z.date(),
});
export const fermentationMethanolDetectorHoldInitializer = z.object({
    id: fermentationMethanolDetectorHoldId.optional(),
    fermentation_id: fermentationId,
    kind: methanolDetectorHoldEnum,
    off_reason: methanolDetectorOffReasonEnum.optional().nullable(),
    started_at: z.date().optional(),
    until: z.date().optional().nullable(),
    ended_at: z.date().optional().nullable(),
    created_by: operatorId.optional().nullable(),
    ended_by: operatorId.optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
});
export const fermentationMethanolDetectorHoldMutator = z.object({
    id: fermentationMethanolDetectorHoldId.optional(),
    fermentation_id: fermentationId.optional(),
    kind: methanolDetectorHoldEnum.optional(),
    off_reason: methanolDetectorOffReasonEnum.optional().nullable(),
    started_at: z.date().optional(),
    until: z.date().optional().nullable(),
    ended_at: z.date().optional().nullable(),
    created_by: operatorId.optional().nullable(),
    ended_by: operatorId.optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
});
//# sourceMappingURL=FermentationMethanolDetectorHold.js.map